import { AxiosInstance } from 'axios';
import { IAuthApi, IResponse } from './types';

class AuthApi implements IAuthApi {
  constructor(
    private readonly axios: AxiosInstance,
    private readonly apiUrl: string = '/accounts'
  ) {}

  login = async (user: string, password: string) => {
    const res: IResponse<boolean> = { response: null, error: null };

    try {
      const loginData = {
        username: user,
        password,
      };
      const response = await this.axios.post(`${this.apiUrl}/login/`, loginData, {auth: loginData});

      res.response = response.data;
      sessionStorage.setItem('username', user);
      sessionStorage.setItem('password', password);
      this.axios.defaults.auth = loginData;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  restorePassword = async (email: string) => {
    const res: IResponse<boolean> = { response: false, error: null };

    try {
      const { data } = await this.axios.post(`${this.apiUrl}/forgot-password`, {
        email,
      });

      res.response = data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  changePassword = async (currentPassword: string, newPassword: string) => {
    const res: IResponse<boolean> = { response: false, error: null };

    try {
      const { data } = await this.axios.post(`${this.apiUrl}/change-password`, {
        currentPassword,
        newPassword,
      });

      res.response = data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };

  logout = async () => {
    const res: IResponse<boolean> = { response: false, error: null };

    try {
      const { data } = await this.axios.post(`${this.apiUrl}/logout`);

      res.response = data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };
}

export default AuthApi;
